<template>
  <div class="control-group">
    <div class="control-label">
      <Label :description="description" :label="label" />
    </div>
    <div class="controls">
      <select v-model="currentOption" class="form-select" @input="$emit('update:value', $event.target.value)">
        <option
          v-for="item in options"
          :key="item.value"
          :value="item.value"
          :selected="value === item.value"
        >
          {{ item.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
    import Label from "./Label";

    export default {
        components: {
            Label
        },
        props: {
            name: null,
            label: null,
            description: null,
            value: null,
            options: null,
            defaultValue: null,
        },
        data() {
            return {
                currentOption: ""
            };
        },
        watch: {
            value: function(newValue){
                this.currentOption = newValue;
            }
        },
        mounted() {
            this.currentOption = this.value ?? this.defaultValue;
            this.$emit('update:value', this.currentOption)
        },
        methods: {

        }
    };
</script>
